import * as React from 'react';

import TuneIcon from '@mui/icons-material/Tune';
import { Button, Drawer, useMediaQuery, useTheme } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';

import styles from './SideFiltersButton.module.css';

export interface SideSearchFiltersButtonProps {
  sideFiltersCount: number;
  toggleSideFiltersForm: () => void;
  isSideFiltersFormOpen: boolean;
  form: React.JSX.Element;
}

export const SideFiltersButton = ({
  sideFiltersCount,
  toggleSideFiltersForm,
  isSideFiltersFormOpen,
  form,
}: SideSearchFiltersButtonProps) => {
  const { T } = useIntl();
  const theme = useTheme();
  const isSMDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <React.Fragment>
      <Button
        variant={isSMDown ? 'outlined' : 'contained'}
        color="secondary"
        className={styles.filterButton}
        size={isSMDown ? 'small' : 'medium'}
        startIcon={<TuneIcon />}
        onClick={toggleSideFiltersForm}
      >
        {T('search_page.filters.filter_amount', sideFiltersCount)}
      </Button>
      <Drawer
        classes={{
          paperAnchorBottom: styles.bottomDrawer,
          paperAnchorRight: styles.rightDrawer,
        }}
        anchor={isSMDown ? 'bottom' : 'right'}
        open={isSideFiltersFormOpen}
        onClose={toggleSideFiltersForm}
      >
        {form}
      </Drawer>
    </React.Fragment>
  );
};
